module.exports = __webpack_public_path__ + "img/logo_v2.9fb65bc9.jpg";